// cspell: ignore ponyfill
// TODO: import the ponyfill instead (as a library should do)
export * from 'web-streams-polyfill';
export let AbortController;
({ AbortController } = globalThis);
//# sourceMappingURL=detect.js.map